import { ActionIcon } from "./ActionIcon";
import { ActionRoot } from "./ActionRoot";

export const Action = {
  Root: ActionRoot,
  Icon: ActionIcon,
};
